import { enUS, GRID_DEFAULT_LOCALE_TEXT, GridLocaleText } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'

export const getDataGridLocaleText = (lang: string, t: TFunction) => {
    switch (lang) {
        case 'zh':
            return translateLocaleText(t)
        case 'id':
            return translateLocaleText(t)
        default:
            return enUS.components.MuiDataGrid.defaultProps.localeText
    }
}

const translateLocaleText = (t: TFunction): GridLocaleText => ({
    ...GRID_DEFAULT_LOCALE_TEXT,
    noRowsLabel: t('table.locale.noRowsLabel', 'No rows'),
    noResultsOverlayLabel: t('table.locale.noResultsFound', 'No results found.'),
    errorOverlayDefaultLabel: t('table.locale.errorOverlayDefaultLabel', 'An error occurred.'),

    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',

    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',

    // Filters toolbar button text
    toolbarFilters: t('table.locale.toolbarFilters', 'FILTERS'),
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: count => (count !== 1 ? `${count} active filters` : `${count} active filter`),

    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',

    // Columns panel text
    columnsPanelTextFieldLabel: t('table.locale.findColumn', 'Find column'),
    columnsPanelTextFieldPlaceholder: t('table.locale.columnTitle', 'Column title'),
    columnsPanelDragIconLabel: t('table.locale.reorderColumn', 'Reorder column'),
    columnsPanelShowAllButton: t('button.showAll', 'Show all'),
    columnsPanelHideAllButton: t('button.hideAll', 'Hide all'),

    // Filter panel text
    filterPanelAddFilter: t('button.addFilter', 'Add filter'),
    filterPanelDeleteIconLabel: t('button.delete', 'Delete'),
    filterPanelOperators: t('table.locale.filterPanelOperators', 'Operators'),
    filterPanelOperatorAnd: t('general.information.andFields', 'And'),
    filterPanelOperatorOr: t('general.information.orFields', 'Or'),
    filterPanelColumns: t('general.table.column', 'Columns'),
    filterPanelInputLabel: t('general.information.value', 'Value'),
    filterPanelInputPlaceholder: t('general.information.filterValue', 'Filter value'),

    // Filter operators text
    filterOperatorContains: t('general.information.containValueFields', 'contains'),
    filterOperatorEquals: t('general.information.equalValueFields', 'equals'),
    filterOperatorStartsWith: t('general.information.startsWithValueFields', 'starts with'),
    filterOperatorEndsWith: t('general.information.endsWithValueFields', 'ends with'),
    filterOperatorIs: t('general.information.isValueFields', 'is'),
    filterOperatorNot: t('general.information.isNotValueFields', 'is not'),
    filterOperatorAfter: t('general.information.isAfterValueFields', 'is after'),
    filterOperatorOnOrAfter: t('general.information.isOnOrAfterValueFields', 'is on or after'),
    filterOperatorBefore: t('general.information.isBeforeValueFields', 'is before'),
    filterOperatorOnOrBefore: t('general.information.isOnOrBeforeValueFields', 'is on or before'),

    // Filter values text
    filterValueAny: t('general.information.anyValueFields', 'any'),
    filterValueTrue: t('general.option.true', 'true'),
    filterValueFalse: t('general.option.false', 'false'),

    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Show columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',

    // Column header text
    columnHeaderFiltersTooltipActive: count => (count !== 1 ? `${count} active filters` : `${count} active filter`),
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',

    // Rows selected footer text
    footerRowSelected: count =>
        count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,

    // Total rows footer text
    footerTotalRows: 'Total Rows:',

    // Total visible rows footer text
    footerTotalVisibleRows: (visibleCount, totalCount) =>
        `${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,

    // Checkbox selection text
    // checkboxSelectionHeaderName: 'Checkbox selection',

    // Boolean cell text
    // booleanCellTrueLabel: 'true',
    // booleanCellFalseLabel: 'false',

    // Used core components translation keys
    // MuiTablePagination: {},
})
